export default __webpack_public_path__ + "static/media/back_header.a77d519d.svg";